import { useState, useEffect } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useHomePage = () => {
  const [dishes, setDishes] = useState([]);
  const [events, setEvents] = useState([]);
  const [cities, setCities] = useState([]);

  const [cityTitle, setCityTitle] = useState('ba');

  const [error, setError] = useState(false);
  
  const { authed, cityId, setCity, token } = useAuth();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const headers = {
      "Content-Type": "application/json",
    };
    if (authed) {
      headers["Authorization"] = `Token ${token}`;
    }
    let url = "/homepage";
    if (cityId) {
      url = `/homepage?city_id=${cityId}`;
    }    
    fetch(`${apiRoot}${url}`, {
      headers
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setDishes(json.dishes);
            setEvents(json.events);
            console.log(json.events)
            setCities(json.cities);
            if (json.cities.length) {
              const city = json.cities.find(c => c.id === cityId);
              if (city) {
                setCityTitle(city.title);
              }
            }
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setDishes([]);
          setEvents([]);
          setCities([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setDishes([]);
        setEvents([]);
        setCities([]);
        setLoading(false);
      });
  }, [authed, token, cityId]);

  useEffect(() => {
    if (cities.length) {
      const city = cities.find(c => c.id === cityId);
      if (!city) {
        setCity(cities[0].id);
      }
    }

  }, [cities, cityId, setCity]);

  return {
    dishes,
    events,
    cities,
    error,
    cityTitle,
    loading,
  };
};

export default useHomePage;
